export default "__VITE_ASSET__yjYs6CFE__"